import { render, staticRenderFns } from "./GiftSelector.vue?vue&type=template&id=c2481a22&"
import script from "./GiftSelector.vue?vue&type=script&lang=js&"
export * from "./GiftSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../DM.Umbraco.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports